{
    "image_upload_error": "Fehler beim Hochladen des Bildes. Versuchen Sie diese Seite neu zu laden und wählen Sie erneut ein Bild.",
    "search_placeholder": "Fotos und Illustrationen durchsuchen",
    "search": "Suchen",
    "photo": "Bild",
    "image_by": "von",
    "free_photos_from": "Kostenlose Lagerbilder von",
    "uploading": "Hochladen",
    "cancel": "Abbrechen",
    "select": "Auswählen"
}
